import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const NonEditableIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: "15px", height: "15px", viewBox: "0 0 15 15" }, props), /* @__PURE__ */ React.createElement("g", { id: "Polls-Desktop", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { id: "WOW-Poll-/-Added-Poll-/-Edit-Mode", transform: "translate(-875.000000, -558.000000)" }, /* @__PURE__ */ React.createElement("g", { id: "Group-6", transform: "translate(871.000000, 553.000000)" }, /* @__PURE__ */ React.createElement("g", { id: "01-Foundation-/-Icon-Medium-24-(Default)-/-01-Actions-/-01-Edit", fill: "#FFFFFF" }, /* @__PURE__ */ React.createElement("path", { d: "M16.679,5.60187506 L18.381,7.30587506 C19.207,8.13287506 19.207,9.47787506 18.381,10.3058751 L10.211,18.4858751 L4,19.9998751 L5.512,13.7818751 L13.682,5.60187506 C14.481,4.79987506 15.878,4.79887506 16.679,5.60187506 Z M8.66091072,16.0462125 L9.973,17.3598751 L15.625,11.7018751 L12.289,8.36087506 L6.637,14.0198751 L7.95422762,15.3386821 L11.1467061,12.1463747 C11.3419735,11.9511178 11.6585559,11.9511262 11.8538129,12.1463936 C12.0490698,12.341661 12.0490613,12.6582435 11.8537939,12.8535004 L8.66091072,16.0462125 Z M16.306,11.0198751 L17.7,9.62387506 C18.15,9.17287506 18.15,8.43787506 17.7,7.98687506 L15.998,6.28287506 C15.561,5.84587506 14.801,5.84687506 14.364,6.28287506 L12.97,7.67887506 L16.306,11.0198751 Z M5.426,18.5738751 L8.995,17.7438751 L6.254,14.9988751 L5.426,18.5738751 Z" })), /* @__PURE__ */ React.createElement(
  "line",
  {
    x1: "7",
    y1: "7",
    x2: "17.9601551",
    y2: "17.9601551",
    stroke: "#FFFFFF",
    strokeLinecap: "square"
  }
)))));

export { NonEditableIcon };
//# sourceMappingURL=NonEditableIcon.js.map
